import { useState } from 'react';
import { SmartTooltip } from '~/commonComponents/SmartTooltip/SmartTooltip';
import HeartIcon from '~/images/icons/Heart';
import { Colors } from '~/themes/colors';

interface IFavoriteHeartButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isFavorite?: boolean;
}

export const FavoriteHeartButton = ({
  onClick,
  disabled = false,
  isFavorite = false,
}: IFavoriteHeartButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const getHeartColor = () => {
    if (isFavorite) {
      return isHovered ? Colors.favorites_350 : Colors.favorites_400;
    }
    return Colors.favorites_400;
  };

  const getOutline = () => {
    if (isFavorite) return false;
    return !isHovered;
  };

  const tooltipContent = isFavorite ? 'Remove' : 'Add to Favorites';

  return (
    <div
      style={{
        position: 'absolute',
        top: 10,
        right: 12,
      }}
    >
      <SmartTooltip
        content={tooltipContent}
        position="bottom"
        alignment="center"
        trigger="hover"
        className="smart-tooltip"
        disabled={disabled}
      >
        <button
          type="button"
          data-testid="favorite-heart-button"
          disabled={disabled}
          onClick={disabled ? undefined : onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            all: 'unset',
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.4 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            filter: isHovered ? 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))' : 'none',
            transition: 'filter 0.2s',
          }}
        >
          <HeartIcon color={getHeartColor()} outline={getOutline()} width={25} height={25} />
        </button>
      </SmartTooltip>
    </div>
  );
};
